define('services/localeService',[
        'lib/lodash4',
        'jquery',
        'require',
        'lib/knockout',
        'lib/bluebird',
        'config',
        'util/queryParamParser',
        'util/errorCallbackFactory',
        'extensions/i18n/knockout.i18n',
        'services/authService',
        'json!strings/en-US.json', // ensure english strings will be included in app by build
        'json!strings/tags.json',
        'lib/cultures/globalize.culture.en-US' // ensure that the en-US locale gets loaded in case a locale fails to load
    ],
    function(
        _,
        $,
        require,
        ko,
        Promise,
        config,
        queryParser,
        errorCallbackFactory,
        i18n,
        authService,
        englishStrings,
        tags
        ) {
        'use strict';

        var localePromises = {};
        var initialized = ko.observable(false);


        /**
         * Takes the locale from directory - formatted like "en_us" or "pt_br" and turns it into a locale formatted like
         * "en-US" or "pt-BR".  The latter is the IEFT standard - the former is the standard employed by directory.
         * @param locale
         * @returns {*}
         */
        function toLocaleFormat(locale){
            if ( locale ){
                var localeComponents = locale.split(/[-_.]/ig);
                var lang = localeComponents.shift();
                var region = localeComponents.shift();

                if ( lang ){
                    lang = lang.toLowerCase();
                }

                if ( region ){
                    locale = lang + '-' + region.toUpperCase();
                }
            }
            return locale;
        }

        function setupLocale (resolve, locale, strings) {
            i18n.registerStrings(englishStrings, 'en-US');
            i18n.registerStrings(strings, locale);
            i18n.registerTags(tags);

            initialized(true);

            resolve(locale);
        }

        /**
         * Checks to see if the current application locale is set to the passed locale, and
         * if not, reloads the page.
         */
        function checkAppLocale (desiredLocale) {
            var appLocale = ko.i18n.getLocale();
            if (desiredLocale  && appLocale && desiredLocale != appLocale) {
                window.location.reload();
            }
        }

        /**
         * Module for requesting that locale data be loaded into the application.
         * @exports services/localeService
         */
        var localeService = {

            initialized: ko.computed(function() {
                return initialized();
            }),

            /**
             * Gets the current locale the application should be in, based on user preferences, browser config, and default settings.
             */
            getAppLocale: function () {
                var queryLocale = queryParser.getParameterValue('locale');
                var defaultLocale = navigator.language || navigator.userLanguage || config.defaultLocale;  //userLanguage is for IE10
                if (queryLocale) {
                    var segments = queryLocale.replace('_','-').split('-');
                    if (segments.length > 1) {
                        return segments[0] + '-' + segments[1].toUpperCase();
                    } else {
                        return queryLocale;
                    }
                }

                if ( authService.principalId() && authService.userLocale() ) {
                    return toLocaleFormat( authService.userLocale());
                }
                return toLocaleFormat( defaultLocale );
            },

            /**
             * Requests that the provided locale data be loaded into the application.
             *
             * After loading, a locale's localized string registry will be available
             * to the application and number/date/currency formatting will work for
             * that locale via the {@link i18n} module.
             *
             * @param {String} locale the locale to load.
             * @returns {Promise} a promise object that will be resolved when the locale
             *         files have been loaded
             */
            loadLocale: function (locale) {
                if(locale === 'en-US') {
                    setupLocale(function() {}, locale, englishStrings);
                    return Promise.cast(locale);
                }

                var localePromise = localePromises[locale] || new Promise(function (resolve) {
                    var cdnUrl = config.cdnUrl || '';
                    var stringsDir = config.stringsDirectory;
                    var onLocaleLoad = _.partial(setupLocale, resolve, locale);
                    //use US english by default if we can't find the locale we're looking for.
                    var localeLoadFailureHandler = _.partial(setupLocale, resolve, 'en-US', englishStrings);

                    require([
                                'json!' + stringsDir + '/' + locale + '.json',
                                cdnUrl + 'js/lib/cultures/globalize.culture.' + locale + '.js'
                        ],
                        onLocaleLoad,
                        localeLoadFailureHandler
                    );
                });
                localePromises[locale] = localePromise;

                return localePromise;
            }
        };

        /**
         * Once the authentication process is complete, check to see if the
         * current locale is correct, and if not, reload the page.
         */
        ko.computed(function () {
            if (authService.initialized()) {
                checkAppLocale( localeService.getAppLocale() );
            }
        });

        return localeService;
    });

